import React, { Component } from 'react';
import styles from './styles.scss';

import backgroundSrc from './purple.png';

class AuthLayout extends Component {
  render() {
    const { children } = this.props;

    const style = {
      backgroundImage: `url(${backgroundSrc})`,
    };

    return (
      <div className={styles.layout} style={style}>
        <div className={styles.content}>{children}</div>
        <div className={styles.aside}>
          <div className={styles.asideHeader}>Finally</div>
          <div className={styles.asideContent}>
            Test prep
            <br />
            designed
            <br />
            for <b className={styles.you}>you</b>.
          </div>
        </div>
      </div>
    );
  }
}

export default AuthLayout;
